import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card.jsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs.jsx";
import InternalTicketStats from './InternalTicketStats';
import TicketsByStatusChart from './TicketsByStatusChart';
import TicketsByPriorityTable from './TicketsByPriorityTable';
import RecentTickets from './RecentTickets';
import CompanyList from './CompanyList';
import SlaPerformance from './SlaPerformance';
import UserPerformance from './UserPerformance';
import { User, Client } from '../../api/supabaseEntities.js';

import QuickActions from './QuickActions';
import ClientList from './ClientList';

export default function InternalDashboard({ data, user, isLoading }) {
  const { tickets = [], companies = [], stats = {} } = data || {};
  const isAdmin = user?.role === 'admin';

  // Buscar lista de usuários
  const [users, setUsers] = React.useState([]);
  React.useEffect(() => {
    User.list().then(setUsers).catch(() => setUsers([]));
  }, []);

  const [clients, setClients] = React.useState([]);
  React.useEffect(() => {
    Client.list({ status: 'active' }).then(setClients).catch(() => setClients([]));
  }, []);

  return (
    <>
      <QuickActions isAdmin={isAdmin} />
      
      <InternalTicketStats 
        stats={stats.tickets || {
          total: 0,
          open: 0,
          overdue: 0,
          resolved: 0
        }}
        isLoading={isLoading}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Chamados por Status</CardTitle>
          </CardHeader>
          <CardContent>
            <TicketsByStatusChart 
              tickets={tickets}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Performance SLA</CardTitle>
          </CardHeader>
          <CardContent>
            <SlaPerformance
              tickets={tickets}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Chamados por Prioridade</CardTitle>
          </CardHeader>
          <CardContent>
            <TicketsByPriorityTable 
              tickets={tickets}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Performance por Atendente</CardTitle>
          </CardHeader>
          <CardContent>
            <UserPerformance 
              tickets={tickets}
              users={users}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>
      </div>



      <Tabs defaultValue="recent">
        <TabsList>
          <TabsTrigger value="recent">Chamados Recentes</TabsTrigger>
          <TabsTrigger value="companies">Empresas Ativas</TabsTrigger>
        </TabsList>
        <TabsContent value="recent">
          <RecentTickets 
            tickets={tickets}
            isLoading={isLoading}
            isInternalUser={true}
          />
        </TabsContent>
        <TabsContent value="companies">
          <ClientList 
            clients={clients}
            isLoading={isLoading}
          />
        </TabsContent>
      </Tabs>
    </>
  );
}